import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select';
import { toast } from 'react-toastify';
import useApiCallHooks from '../../../../hooks/useApiCallHooks';
import AdminAppBody from '../../../../components/admin/AdminAppBody';

const ProgramServiceEditForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const passedType = location.state?.type || '';
  const passedProgramId = location.state?.program_id || '';

  const [form, setForm] = useState({
    type: '',
    program_id: '',
    file: null,
  });

  const [errors, setErrors] = useState({});
  const [typeOptions] = useState([
    { value: 'student', label: 'Student' },
    { value: 'kids', label: 'Kids' },
  ]);
  const [programOptions, setProgramOptions] = useState([]);

  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
  const [studentresponce, , studentError, callStudentAPI] = useApiCallHooks();

  // Fetch record by ID
  useEffect(() => {
    if (id) {
      callAPI('get', `admin/program-resource/${id}`);
    }
  }, [id]);

  // Set form data when API loads
  useEffect(() => {
    if (responce?.data && statusCode === 200) {
      const data = responce.data;
      const finalType = passedType || 'student';

      setForm({
        type: finalType,
        program_id: parseInt(data.program_id) || '',
        file: null,
      });

      if (finalType) {
        callStudentAPI('get', `get-program-student-list/${finalType}`);
      }
    }
  }, [responce, statusCode, passedType]);

  // Set program options based on fetched programs
  useEffect(() => {
    if (studentresponce?.data?.programs) {
      const mapped = studentresponce.data.programs.map((p) => ({
        value: p.id,
        label: p.name,
      }));
      setProgramOptions(mapped);
    }
  }, [studentresponce]);

  // Error display
  // useEffect(() => {
  //   if (error) toast.error(error?.message || 'Something went wrong');
  //   if (studentError) toast.error(studentError?.message || 'Program fetch failed');
  // }, [error, studentError]);

  const handleTypeChange = (selectedOption) => {
    const selectedType = selectedOption?.value || '';
    setForm({ ...form, type: selectedType, program_id: '' });
    setProgramOptions([]);
    setErrors((prev) => ({ ...prev, type: '', program_id: '' }));

    if (selectedType) {
      callStudentAPI('get', `get-program-student-list/${selectedType}`);
    }
  };

  const handleProgramChange = (selectedOption) => {
    setForm((prev) => ({
      ...prev,
      program_id: selectedOption?.value ? parseInt(selectedOption.value) : '',
    }));
    setErrors((prev) => ({ ...prev, program_id: '' }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setForm((prev) => ({
      ...prev,
      file: file,
    }));
    setErrors((prev) => ({ ...prev, file: '' }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!form.type) newErrors.type = 'Type is required';
    if (!form.program_id) newErrors.program_id = 'Program is required';
    if (!form.file) newErrors.file = 'File is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const payload = new FormData();
    payload.append('type', form.type);
    payload.append('program_id', form.program_id);
    payload.append('file', form.file);
    payload.append('_method', "PUT");

    callAPI(
      'post',
      `admin/program-resource/${id}`,
      payload,
      (res) => {
        toast.success(res?.message || 'Updated successfully!');
        navigate('/program-service/list');
      },
      true
    );
  };
  useEffect(()=>{
    if(statusCode===202&& 204){
      navigate('/program-service/list')
    }
  },[statusCode])

  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="container mt-4">
          <h4 className="mb-4">Edit Program Service</h4>
          <form onSubmit={handleSubmit} encType="multipart/form-data">
            <div className="row">
              {/* Type */}
              <div className="col-md-6 mb-3">
                <label className="form-label">Type <span className="text-danger">*</span></label>
                <Select
                  options={typeOptions}
                  value={typeOptions.find((opt) => opt.value === form.type) || null}
                  onChange={handleTypeChange}
                  placeholder="Select type"
                  isClearable
                />
                {errors.type && <div className="text-danger">{errors.type}</div>}
              </div>

              {/* Program */}
              <div className="col-md-6 mb-3">
                <label className="form-label">Program <span className="text-danger">*</span></label>
                <Select
                  options={programOptions}
                  value={programOptions.find((opt) => opt.value === form.program_id) || null}
                  onChange={handleProgramChange}
                  placeholder="Select program"
                  isDisabled={!form.type}
                  isClearable
                />
                {errors.program_id && <div className="text-danger">{errors.program_id}</div>}
              </div>

              {/* File Upload */}
              <div className="col-md-12 mb-3">
                <label className="form-label">Upload (Only pdf) <span className="text-danger">*</span></label>
                <input
                  type="file"
                  name="file"
                  onChange={handleFileChange}
                  className="form-control"
                />
                {errors.file && <div className="text-danger">{errors.file}</div>}
              </div>

              {/* Submit */}
              <div className="col-12">
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? 'Saving...' : 'Update'}
                </button>
              </div>
            </div>
          </form>
        </div>
      }
    />
  );
};

export default ProgramServiceEditForm;
